let Constants = {
    firebaseKeys : {
    apiKey: "AIzaSyA3Du28b_PgVg_28PnycWLiCfcLFPkvDzo",
    authDomain: "toolsvilla.firebaseapp.com",
    databaseURL: "https://toolsvilla.firebaseio.com",
    projectId: "toolsvilla",
    storageBucket: "toolsvilla.appspot.com",
    messagingSenderId: "265541977908",
    appId: "1:265541977908:web:4ad3b491ffbbe01bfa0761",
    measurementId: "G-FP4XCR84FG"
}
}
export default Constants;